(function(){
 'use strict';
 if(window.__neoIntegrated){window.__neoIntegrated.init(document);return;}
 var roots=new WeakMap();
 function initRoot(root){
  if(roots.has(root))return;
  function onClick(event){
   if(!(event.target instanceof Element))return;
   var buyLink=event.target.closest('[data-ni-back-to-buy]');
   if(buyLink&&root.contains(buyLink)){
    var purchase=document.querySelector('[id^="MainProduct-"]')||document.getElementById('MainContent');
    if(purchase){event.preventDefault();purchase.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});}
    return;
   }
   var featureLink=event.target.closest('a[href^="#neo-"]');
   if(featureLink&&root.contains(featureLink)&&!(window.Shopify&&window.Shopify.designMode)){
    var targets={'#neo-process':'.ni-process','#neo-technology':'.ni-technology','#neo-control':'.ni-tech-control-shell','#neo-serving':'.ni-serving','#neo-explore':'.ni-explore','#neo-kits':'.ni-explore-kits','#neo-personalize':'.ni-personalize','#neo-app':'.ni-app','#neo-care':'.ni-care'};
    var selector=targets[featureLink.getAttribute('href')];
    var featureTarget=selector&&document.querySelector(selector);
    if(!featureTarget&&featureLink.getAttribute('href')==='#neo-control')featureTarget=document.querySelector('.ni-tech-upgrades');
    if(featureTarget){event.preventDefault();featureTarget.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});return;}
   }
   var button=event.target.closest('[data-ni-scroll],[data-neo-scroll]');
   if(!button||!root.contains(button))return;
   var track;try{track=root.querySelector(button.getAttribute('data-ni-scroll')||button.getAttribute('data-neo-scroll'));}catch(error){return;}
   if(!track)return;
   var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
   var direction=button.getAttribute('data-ni-direction')||button.getAttribute('data-neo-scroll-direction');
   track.scrollBy({left:Math.max(220,track.clientWidth*.85)*(direction==='prev'?-1:1),behavior:reduced?'auto':'smooth'});
  }
  function onBlockSelect(event){var item=event.target.closest&&event.target.closest('.ni-faq-list details');if(item&&root.contains(item))item.open=true;}
  root.addEventListener('click',onClick);
  root.addEventListener('shopify:block:select',onBlockSelect);
  roots.set(root,function(){root.removeEventListener('click',onClick);root.removeEventListener('shopify:block:select',onBlockSelect);});
 }
 function each(scope,fn){if(scope.matches&&scope.matches('.neo-i'))fn(scope);if(scope.querySelectorAll)scope.querySelectorAll('.neo-i').forEach(fn);}
 function init(scope){each(scope,initRoot);}
 window.__neoIntegrated={init:init};
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
 document.addEventListener('shopify:section:unload',function(event){each(event.target,function(root){var cleanup=roots.get(root);if(cleanup)cleanup();roots.delete(root);});});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
}());

/* Keep Neo product content on this page; retain cards, media and purchase actions. */
(function(){
 'use strict';
 if(document.querySelector('[data-neo-reservation][data-mode="deposit"]'))return;
 if(window.__neoPdpLinkCleanup)return;
 window.__neoPdpLinkCleanup=true;
 var selector='.neo-i.neo-illustrated,.neo-native-machine';
 function cleanRoot(root){
  root.querySelectorAll('a[href]').forEach(function(link){
   var href=link.getAttribute('href');
   if(!href||href.charAt(0)==='#'||link.hasAttribute('data-ni-back-to-buy'))return;
   try{var target=new URL(href,document.baseURI);if(target.origin===location.origin&&target.pathname===location.pathname)return;}catch(error){return;}
   if(link.matches('.ni-link,.ni-kit-detail,.ni-kit-collection-link,.mc-s4b')){link.remove();return;}
   link.removeAttribute('href');link.removeAttribute('target');link.removeAttribute('rel');link.removeAttribute('tabindex');
  });
 }
 function clean(scope){if(scope.matches&&scope.matches(selector))cleanRoot(scope);if(scope.querySelectorAll)scope.querySelectorAll(selector).forEach(cleanRoot);}
 document.addEventListener('shopify:section:load',function(event){clean(event.target);});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){clean(document);},{once:true});else clean(document);
}());
